import '@fontsource/roboto';

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'light',
    primary: {
      main: '#263c6a',
    },
    secondary: {
      main: '#2EB6E7',
    },
    background: {
      default: '#ececec',
      paper: '#ffffff',
    },
    text: {
      disabled: '#b3b3b3',
      primary: '#263c6a',
      secondary: '#666666',
    },
    info: {
      main: '#2EB6E7',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 400,
          transform: 'translate(5px, -25px)',
          color: 'var(--mui-palette-text-primary)',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          '&.Mui-error': {
            border: '1px solid var(--mui-palette-error-main)',
          },
        },
        underline: {
          '&&&:before': {
            borderBottom: 'none',
          },
          '&&:after': {
            borderBottom: 'none',
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          textAlign: 'center',
        },
        head: {
          backgroundColor: 'var(--mui-palette-background-default)',
          fontSize: '20px',
          fontWeight: 700,
          textAlign: 'center',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: 'var(--mui-palette-text-secondary)',
          fontSize: '14px',
        },
        spacer: {
          display: 'none',
          fontSize: '10px',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
        },
      },
    },
  },
});

export default theme;
